import { Animal } from "components/Signup/store/state/types";
import { SpeciesEnum } from "../../../../../__generated__/globalTypes";
import { dateValid, dateValidMax, dateValidMin } from "utils/validation";
import { subMonths } from "date-fns";
import { MAX_AGE_CAT, MAX_AGE_DOG } from "components-shared/insuranceData";

export const isValidAnimalSpecies = (animal: Animal) => Boolean(animal.species);
export const isValidAnimalName = (animal: Animal) => Boolean(animal.name);
export const isValidAnimalBreed = (animal: Animal) =>
  animal.breed?.id === "DogBreed-blandras"
    ? Boolean(animal.breed) &&
      Boolean(animal.mixedBreedFHalf) &&
      Boolean(animal.mixedBreedSHalf)
    : Boolean(animal.breed);
export const isValidAnimalSex = (animal: Animal) => Boolean(animal.sex);
export const isValidAnimalSexSituation = (animal: Animal) =>
  Boolean(animal.sexSituation);
export const isValidAnimalAccess = (animal: Animal) =>
  animal.species === SpeciesEnum.cat ? Boolean(animal.access) : true;
export const isValidAnimalBirthday = (animal: Animal) => {
  if (!animal.birthday) {
    return false;
  }

  return (
    dateValid(animal.birthday) &&
    dateValidMin(
      new Date(animal.birthday),
      subMonths(
        new Date(),
        animal.species === SpeciesEnum.dog ? MAX_AGE_DOG : MAX_AGE_CAT
      )
    ) &&
    dateValidMax(new Date(animal.birthday), new Date())
  );
};

const validAnimalRules = [
  isValidAnimalSpecies,
  isValidAnimalName,
  isValidAnimalBreed,
  isValidAnimalSex,
  isValidAnimalSexSituation,
  isValidAnimalAccess,
  isValidAnimalBirthday,
];

export const isValidAnimal = (animal: Animal) => {
  return validAnimalRules.every((rule) => rule(animal));
};
